import { useState } from 'react';
import { createContainer } from '../../../utils/container';
function useDialectWalletStatesHolder() {
    const [walletConnected, setWalletConnected] = useState(false);
    const [connectionInitiated, setConnectionInitiated] = useState(false);
    const [hardwareWalletForced, setHardwareWalletForced] = useState(false);
    const [isSigningFreeTransaction, setIsSigningFreeTransaction] = useState(false);
    const [isSigningMessage, setIsSigningMessage] = useState(false);
    const [isEncrypting, setIsEncrypting] = useState(false);
    return {
        walletConnected: {
            get: walletConnected,
            set: setWalletConnected,
        },
        connectionInitiatedState: {
            get: connectionInitiated,
            set: setConnectionInitiated,
        },
        hardwareWalletForcedState: {
            get: hardwareWalletForced,
            set: setHardwareWalletForced,
        },
        isSigningFreeTransactionState: {
            get: isSigningFreeTransaction,
            set: setIsSigningFreeTransaction,
        },
        isSigningMessageState: {
            get: isSigningMessage,
            set: setIsSigningMessage,
        },
        isEncryptingState: {
            get: isEncrypting,
            set: setIsEncrypting,
        },
    };
}
export const DialectWalletStatesHolder = createContainer(useDialectWalletStatesHolder);
//# sourceMappingURL=index.js.map